<template>
    <div class="goodsList">
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="商品名称" class-name="imgnameBox">
                <template slot-scope="scope">
                    <div class="imgname">
                        <div class="coverattid">
                            <img :src="scope.row.coverattid" alt="">
                        </div>
                        <div class="nameprice">
                            <div class="name">{{scope.row.kmcname}}</div>
                            <div class="coursetypenamePrice">
                                <span class="coursetypenamePrice" v-if="scope.row.kmctype === 7">{{scope.row.coursetypename}}</span>
                                <span class="price">￥{{scope.row.saleprice}}</span>
                            </div>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="kmctypename" label="类型" class-name="center"></el-table-column>
            <el-table-column prop="ordercount" label="付款件数" class-name="center"></el-table-column>
            <el-table-column prop="ordercustomercount" label="付款人数" class-name="center"></el-table-column>
        </el-table>
        <Page :total="page.total" @getList="getCoupnvoucherInfoByCustomasset" />
    </div>
</template>
<script>
import {getCoupnvoucherInfoByCustomasset} from 'api/marketingCenterApi'
import {mapActions} from 'vuex'
import Page from 'base/page/page3'
export default {
    data() {
        return {
            params: {
                couponvoucherid: this.$route.query.couponvoucherid
            },
            page: {
                page: 1,
                pageSize: 10,
                total: 0
            },
            tableData: []
        }
    },
    created() {
    },
    mounted() {
        this.getCoupnvoucherInfoByCustomasset(this.page)
    },
    methods: {
        getCoupnvoucherInfoByCustomasset(page) {
            this.setLoading(true)
            const params = {
                page: page.page,
                pageSize: page.pageSize,
                couponvoucherid: this.params.couponvoucherid
            }
            getCoupnvoucherInfoByCustomasset({
                data: params,
                success: res => {
                    // const obj = {
                    //     coverattid: require('@/common/images/brandBusiness/logo_brandBusiness.png'),
                    //     kmcname: '科创板上市深度解读- 60分钟读懂科创板',
                    //     kmctype: 8,
                    //     ordercount: 70,
                    //     ordercustomercount: 70,
                    //     saleprice: '99.99',
                    //     coursetypename: '系列课'
                    // }
                    this.tableData = res.data.content
                    if (page.page === 1) {
                        this.page.total = res.data.pageinfo.rowCount
                    }
                    this.setLoading(false)
                },
                error: res => {
                    this.setLoading(false)
                    this.$message.error(res.msg)
                }
            })
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        Page
    }
}
</script>
<style lang="scss">
    .goodsList {
        .el-table {
            .imgnameBox {
                .imgname {
                    display: flex;
                    .coverattid {
                        width: 106px;
                        height: 60px;
                        margin-right: 10px;
                        img {
                            width: 106px;
                            height: 60px;
                        }
                    }
                    .nameprice {
                        .name {
                            font-size: 14px;
                            line-height: 20px;
                            width: 304px;
                            text-overflow: -o-ellipsis-lastline;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            display: -webkit-box;
                            -webkit-line-clamp: 2;
                            line-clamp: 2;
                            -webkit-box-orient: vertical;
                        }
                        .coursetypenamePrice {
                            color: #F56C6C;
                            margin-top: 6px;
                            .coursetypenamePrice {
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }
            .center {
                .cell {
                    text-align: center;
                }
            }
        }
    }
</style>